<template>
  <div class="preview-default">
    <h1 class="text-center">会员申请登记表</h1>
    <div class="padding-top-20"></div>
    <table class="preview-table">
      <tbody>
        <tr>
          <td class="title-h1" rowspan="7"><span>申请信息</span></td>
          <td class="title"><span>公司名称</span></td>
          <td colspan="3">{{guarantorModel.name}}</td>
          <td class="title"><span>成立日期</span></td>
          <td colspan="2">{{guarantorModel.estDate?require('moment')(guarantorModel.estDate).format('YYYY-MM-DD'):null}}</td>
        </tr>
        <tr>
          <td class="title"><span>社会信用代码</span></td>
          <td colspan="3">{{guarantorModel.businessLicense}}</td>
          <td class="title"><span>公司类型</span></td>
          <td colspan="2">{{guarantorModel.corpType}}</td>
        </tr>
        <tr>
          <td class="title"><span>网址</span></td>
          <td colspan="3">{{guarantorModel.homepage}}</td>
          <td class="title"><span>邮箱</span></td>
          <td colspan="2">{{guarantorModel.email}}</td>
        </tr>
        <tr>
          <td class="title"><span>住所</span></td>
          <td colspan="6">{{guarantorModel.address}}</td>
        </tr>
        <tr>
          <td class="title" rowspan="2"><span>注册资本（万）</span></td>
          <td rowspan="2">{{guarantorModel.capital}}</td>
          <td class="title"><span>实缴资本（万）</span></td>
          <td>{{guarantorModel.capitalPaidIn}}</td>
          <td class="title"><span>实缴出资日期</span></td>
          <td colspan="2">{{guarantorModel.capitalPaidInDate?require('moment')(guarantorModel.capitalPaidInDate).format('YYYY-MM-DD'):'-'}}</td>
        </tr>
        <tr>
          <td class="title"><span>认缴资本（万）</span></td>
          <td>{{guarantorModel.capitalSubscribed}}</td>
          <td class="title"><span>认缴出资日期</span></td>
          <td colspan="2">{{guarantorModel.capitalSubscribedDate?require('moment')(guarantorModel.capitalSubscribedDate).format('YYYY-MM-DD'):'-'}}</td>
        </tr>
        <tr>
          <td class="title"><span>经营范围</span></td>
          <td colspan="6">{{guarantorModel.scope}}</td>
        </tr>
        <tr>
          <td class="title-h1" rowspan="2"><span>法人信息</span></td>
          <td class="title"><span>姓名</span></td>
          <td>{{guarantorModel.legalPersonName}}</td>
          <td class="title"><span>性别</span></td>
          <td>{{guarantorModel.legalPersonGender?'男':'女'}}</td>
          <td class="title"><span>学历</span></td>
          <td>{{guarantorModel.legalPersonEduBackground}}</td>
        </tr>
        <tr>
          <td class="title"><span>职务</span></td>
          <td>{{guarantorModel.legalPersonRole}}</td>
          <td class="title"><span>政治面貌</span></td>
          <td>{{guarantorModel.legalPersonPolitical}}</td>
          <td class="title"><span>联系方式</span></td>
          <td>{{guarantorModel.legalPersonTel}}</td>
        </tr>
        <tr>
          <td class="title-h1" rowspan="2"><span>联系人信息</span></td>
          <td class="title"><span>姓名</span></td>
          <td>{{guarantorModel.contact}}</td>
          <td class="title"><span>性别</span></td>
          <td>{{guarantorModel.contactGender?'男':'女'}}</td>
          <td class="title"><span>部门</span></td>
          <td>{{guarantorModel.contactDept}}</td>
        </tr>
        <tr>
          <td class="title"><span>职务</span></td>
          <td>{{guarantorModel.contactRole}}</td>
          <td><span></span></td>
          <td></td>
          <td class="title"><span>联系方式</span></td>
          <td>{{guarantorModel.contactTel}}</td>
        </tr>
        <tr>
          <td class="title-h1" rowspan="2"><span>申请意见</span></td>
          <td colspan="6">
            <p>
              <span>□会员</span>
              <span style="padding-left:50px;">□理事</span>
              <span style="padding-left:50px;">□常务理事</span>
              <span style="padding-left:50px;">□副会长</span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <p>
              同意入会。
            </p>
            <p style="text-align:right;padding-top:100px;">
              <span>年</span>
              <span style="padding-left:30px;">月</span>
              <span style="padding-left:30px;">日</span>
            </p>
          </td>
        </tr>
        <tr>
          <td class="title-h1"><span>审核意见</span></td>
          <td colspan="6">
            <p style="text-align:right;padding-top:100px">
              <span>年</span>
              <span style="padding-left:30px;">月</span>
              <span style="padding-left:30px;">日</span>
            </p>
          </td>
        </tr>
        <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
          <td colspan="5">
            <div class="padding-top-20"></div>
            <div class="padding-top-20"></div>
            <p><b>单位公章</b></p>
            <div class="padding-top-20"></div>
            <div class="padding-top-20"></div>
            <p><b>法定代表人签字</b></p>
            <div class="padding-top-10"></div>
            <p><b>申请日期：</b></p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'preview-form-default',
  props: {
    guarantorId: {
      type: String || Number,
      default: () => null
    }
  },
  components: {
  },
  data () {
    return {
      loading: false,
      guarantorStatus: null,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
      },
      print: false
    }
  },
  watch: {
    guarantorId: function () {
      this.getGuarantorDetail()
    }
  },
  computed: {
  },
  mounted () {
    this.getGuarantorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getGuarantorDetail () {
      Api.Guarantor.getGuarantorDetail(this.guarantorId).then((res) => {
        Object.assign(this.guarantorModel, res)
        this.guarantorStatus = this.guarantorModel.status
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
        if (err.message.indexOf('该用户未绑定承保人') > -1) {
          this.guarantorStatus = 0
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.preview-table {
  border: 2px solid #000;
  border-spacing: 0;
  border-collapse: collapse;
  width: 756px;
  margin: 0 auto;
  td {
    font-size: 16px;
    padding: 10px 8px;
    border: 1px solid #000;
    &:not(.title) {
    }
    &.title-h1 {
      width: 50px !important;
      font-weight: bold;
      text-align: center;
    }
    &.title {
      width: 100px !important;
      font-weight: bold;
      span {
        max-width: 92px;
        display: inline-block;
        text-align: justify;
        width: 100%;
        text-align-last: justify;
      }
    }
  }
}
</style>
